import React from 'react'
import PropTypes from 'prop-types';

import BaseComponent from 'common/BaseComponent';
import personIcon from './person.png';
import refreshIcon from 'theme/img/refresh.png';
import searchIcon from './search.png';
import settingsIcon from './settings.png';
import LogoutTimer from '../../LogoutTimer'
import {getMessage as msg} from 'MessageBundle'

import theme from './NavigationMenu.scss';

export default class NavigationMenu extends BaseComponent {

    handleTvppRedirect = () => {
        this.logout(this.props.tvppReturnUrl);
    };

    handleLogout = () => {
        this.logout(this.props.tvppLogoutUrl);
    };

    handleSearch =() => {
        window.open('/search', '_blank', 'left=100,top=100,width=1310,height=1024,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes');
    };

    renderPreferencesIcon = () => {
        if (this.props.onPreferencesClick) {
            return (
                <li>
                    <a id="password-lnk" href="#" onClick={this.props.onPreferencesClick} title={msg('navigationMenu.preferencesLnkTitle')}>
                        <img src={personIcon} alt=""/>
                    </a>
                </li>
            );
        }
    };

    renderSettingIcon = () => {
        if (this.props.onSettingsClick) {
            return (
                <li>
                    <a href="#" onClick={this.props.onSettingsClick} title={msg('navigationMenu.settingsLnkTitle')}>
                        <img src={settingsIcon} alt=""/>
                    </a>
                </li>
            );
        }
    };

    render() {
        return (
            <ul>
                <li>
                    <a href="#" onClick={this.props.onRefreshClick} title={msg('navigationMenu.refreshLnkTitle')}>
                        <img src={refreshIcon} alt=""/>
                    </a>
                </li>
                <li>
                    <a id="search-lnk" href="#" className={theme.searchLnk} onClick={this.handleSearch}
                        title={msg('navigationMenu.searchLnkTitle')}>
                        <img src={searchIcon} alt=""/>{msg('navigationMenu.searchLnk')}
                    </a>
                </li>

                {this.renderSettingIcon()}

                {this.renderPreferencesIcon()}

                <li>
                    <a href="#">{msg('navigationMenu.helpLnk')}</a>
                </li>
                <li>
                    <a href="#" onClick={this.handleTvppRedirect} title={msg('navigationMenu.tvppLnkTitle')}>
                        {msg('navigationMenu.tvppLnk')}
                    </a>
                </li>
                <li>
                    <a href="#" onClick={this.handleLogout} title={msg('navigationMenu.logoutLnkTitle')}>
                        {msg('navigationMenu.logoutLnk')}
                    </a>
                </li>
                <li>
                    <LogoutTimer timeout={this.props.logoutTimeout} onTimeOver={this.handleLogout}/>
                </li>
            </ul>
        );
    }
}

NavigationMenu.propTypes = {
    /**
     * Timeout value for the logout timer.
     */
    logoutTimeout: PropTypes.number.isRequired,

    /**
     * T-VPP Return URL to which the user will be navigated on T-VPP link click.
     */
    tvppReturnUrl: PropTypes.string.isRequired,

    /**
     * T-VPP Logout URL to which the user will be navigated on Logout link click.
     */
    tvppLogoutUrl: PropTypes.string.isRequired,

    /**
     * JavaScript function that has to be executed on Refresh link click.
     */
    onRefreshClick: PropTypes.func,

    /**
     * Function invoke by preferences icon click.
     */
    onPreferencesClick: PropTypes.func,

    /**
     * Function invoke by settings icon click.
     */
    onSettingsClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Start/NavigationMenu/index.js